// Customer testimonials
const testimonials = [
  { quote: "Heaven in a box... like nothing you've tasted before.", name: "Nicola" },
  { quote: "F**kin unreal!", name: "Frank Ralph" },
  { quote: "Nom nom nom. Bought as a gift but lucky enough to sample one. Really very tasty", name: "L Taylor-Byrne" },
  { quote: "A slab of sexiness", name: "Frank Ralph" },
  { quote: "OMG - pure heaven! I mean porn on a plate!", name: "Angela Cron" },
  { quote: "Impossible to find a better brownie.... I gotta do it & eat in secret as I can not find it within to share", name: "Rhmona Greaves" },
  { quote: "I couldn't stop thinking about them, I need more now!!", name: "Cara-jade Porritt" },
  { quote: "Let me tell you that I've searched high and low for a brownie this good.", name: "Claire Dutton" },
  { quote: "I didn't share them, not even with my husband. I strategically hid them for myself.", name: "Julie Catlin" },
  { quote: "It leads to say, I was in brownie heaven.", name: "Lee Fielding" },
  { quote: "Words fail me (yummy)", name: "Barbara V." },
  { quote: "Taste is amazing but far too much chocolate coating on top. (Said no one ever!)", name: "Sandra Taylor" },
  { quote: "A little bit heaven in your mouth", name: "Emma Loundes" },
  { quote: "I tried to hide them from the rest of my family as they were so good", name: "Katherine Dolman" },
  { quote: "This darn thing to eat is Mega dangerous & beyond addictive", name: "Rhmona Greaves" },
  { quote: "Much too good for children", name: "Erin Louden's partner" },
  { quote: "Out of this world.. So good so tasty from the first bite through to the last.", name: "Ben Hendry" },
  { quote: "I was so excited when I finally took a bite (well that was a MASSIVE bite let's say)", name: "Sylwia Juzaszek" },
  { quote: "Possibly the most decadent blondie that I have ever tasted!!", name: "Siobhan Griffin" },
  { quote: "Better than sex", name: "Neil Harvey" }
];

// 🎅 Christmas-themed testimonials
const christmasTestimonials = [
  { quote: "Christmas wouldn’t be Christmas without a box of these brownies under the tree.", name: "Laura H." },
  { quote: "Ordered for Christmas Eve – they disappeared before the turkey was even carved!", name: "George P." },
  { quote: "The best edible gift I’ve ever sent – my mum’s still talking about them.", name: "Sarah D." },
  { quote: "These brownies saved my Christmas dessert table.", name: "Anita B." },
  { quote: "Santa left crumbs… and I can’t blame him.", name: "Tom L." },
  { quote: "Gave them as stocking fillers – now everyone expects them every year!", name: "Hannah F." },
  { quote: "Festive, fudgy and absolutely flipping fantastic.", name: "Nic R." },
  { quote: "My partner said they were better than the Christmas pudding. I agree.", name: "J. Walker" }
];

// Determine date range
const now = new Date();
const month = now.getMonth(); // 0 = Jan, 11 = Dec
const day = now.getDate();

// Use a mix of Christmas + normal from 20 Nov to 31 Dec
let activeTestimonials = testimonials;
if ((month === 10 && day >= 20) || month === 11) {
  activeTestimonials = testimonials.concat(christmasTestimonials);
}

// Function to insert a random testimonial
function insertRandomTestimonial() {
  const randomIndex = Math.floor(Math.random() * activeTestimonials.length);
  const testimonial = activeTestimonials[randomIndex];
  const container = document.getElementById('brownie-testimonial');

  if (!container) return;

  container.innerHTML = `
    <div class="testimonial-quote fade-in">
      <blockquote>"${testimonial.quote}"</blockquote>
      <cite>— ${testimonial.name}</cite>
    </div>
  `;
}

// Initialise on load and handle dynamic cart updates
document.addEventListener('DOMContentLoaded', () => {
  insertRandomTestimonial();
  document.addEventListener('-drawer:open', insertRandomTestimonial);
  document.addEventListener(':update', insertRandomTestimonial);
});

// Simple fade-in style
const style = document.createElement('style');
style.textContent = `
  .testimonial-quote {
    text-align: center;
    font-style: italic;
    opacity: 0;
    transform: translateY(5px);
    transition: opacity 0.8s ease, transform 0.8s ease;
  }
  .testimonial-quote.fade-in {
    opacity: 1;
    transform: translateY(0);
  }
  .testimonial-quote blockquote {
    quotes: "“" "”" "‘" "’";
  }
  .testimonial-quote blockquote::before { content: open-quote; }
  .testimonial-quote blockquote::after { content: close-quote; }
  .testimonial-quote cite {
    display: block;
    margin-top: 0.25rem;
    font-weight: 600;
    color: #444;
  }
`;
document.head.appendChild(style);
